import __decorate from "../_virtual/_@oxc-project_runtime@0.147.0/helpers/esm/decorate.js";
import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { msg } from "@lit/localize";
import { pdIcons } from "@progressive-development/pd-icon";
import "@progressive-development/pd-icon/pd-icon";
import { PdConfirmDialog } from "@progressive-development/pd-dialog";
import "@progressive-development/pd-content/pd-notice-box";
import { formatShortDate, formatToTime } from "@progressive-development/pd-utils";
//#region src/wizard-reload-popup/WizardReloadPopup.ts
/**
* WizardReloadPopup - Confirmation dialog for reloading saved wizard progress
*
* Displays an info dialog when saved wizard data is found,
* offering to continue from saved progress or start fresh.
*
* @example
* ```typescript
* const popup = new WizardReloadPopup();
* popup.reloadItem = {
*   timestamp: new Date().toUTCString(),
*   wizardStep: 2
* };
* popup.confirmButtonText = "Fortsetzen";
* popup.cancelButtonText = "Neu beginnen";
*
* popup.addEventListener("pd-dialog-confirm", () => {
*   // User chose to continue from saved state
* });
*
* popup.addEventListener("pd-dialog-cancel", () => {
*   // User chose to start fresh (data will be deleted)
* });
*
* this.shadowRoot.appendChild(popup);
* ```
*/
var WizardReloadPopup = class WizardReloadPopup extends PdConfirmDialog {
	constructor(..._args) {
		super(..._args);
		this._singleButton = false;
		this._dialogType = "info";
		this._dialogTitle = msg("Gespeicherte Daten gefunden", { id: "pdWizard.reload.popup.title" });
	}
	static {
		this.styles = [PdConfirmDialog.styles, css`
      .popup-content {
        display: flex;
        flex-direction: column;
        gap: var(--pd-spacing-md, 1rem);
      }

      .last-modified {
        display: flex;
        align-items: center;
        gap: var(--pd-spacing-xs, 0.25rem);
        color: var(--pd-default-muted-col, #555);
      }

      .last-modified pd-icon {
        --pd-icon-size: 1.2rem;
        flex-shrink: 0;
      }

      .last-modified-value {
        font-weight: bold;
        color: var(--pd-default-dark-col, #000);
      }
    `];
	}
	_renderContent() {
		const timestamp = this.reloadItem?.timestamp ? new Date(this.reloadItem.timestamp) : void 0;
		const dateStr = formatShortDate(timestamp, false);
		const timeStr = formatToTime(timestamp);
		return html`
      <div class="popup-content">
        <div class="last-modified">
          <pd-icon icon="${pdIcons.ICON_DATE_TIME}"></pd-icon>
          <span>
            ${msg("Letzte Bearbeitung:", { id: "pdWizard.reload.popup.lastModified" })}
            <span class="last-modified-value">${dateStr}, ${timeStr}</span>
          </span>
        </div>

        <pd-notice-box type="warning" variant="sidebar">
          ${msg("Bei Neubeginn werden die Daten gelöscht", { id: "pdWizard.reload.popup.warning" })}
        </pd-notice-box>
      </div>
    `;
	}
};
__decorate([property({ type: Object })], WizardReloadPopup.prototype, "reloadItem", void 0);
WizardReloadPopup = __decorate([customElement("wizard-reload-popup")], WizardReloadPopup);
//#endregion
export { WizardReloadPopup };
